import React, { FC, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import './CertificateQRCode.css';

interface CertificateQRCodeProps {
    tokenId: string;
}

const CertificateQRCode: FC<CertificateQRCodeProps> = ({ tokenId }) => {
    const { t } = useTranslation();
    const qrRef = useRef<HTMLDivElement>(null);

    // Generate the URL that will be encoded in the QR code
    // Use the production domain for QR codes to avoid Vercel login redirects
    const certificateUrl = `https://bc.transparencychain.org/?token=${tokenId}`;

    const downloadQRCode = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = url;
            link.download = `certificate-${tokenId}-qr.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="qr-code-container">
            <div>
                <h3>{t('qrCode.title', 'Certificate QR Code')}</h3>
                <p className="qr-code-description">
                    {t('qrCode.description', 'Scan this QR code to view the certificate details. You can download and print it to attach to your physical product.')}
                </p>
            </div>
            <div className="qr-code-content">
                <div className="qr-code-wrapper" ref={qrRef}>
                    <QRCodeCanvas
                        value={certificateUrl}
                        size={200}
                        level="H"
                        includeMargin={true}
                    />
                </div>
                <button onClick={downloadQRCode} className="download-qr-button">
                    {t('qrCode.downloadButton', 'Download QR Code')}
                </button>
            </div>
            <p className="qr-code-url">
                <strong>{t('qrCode.urlLabel', 'Direct Link:')}</strong>
                <br />
                <a href={certificateUrl} target="_blank" rel="noopener noreferrer">
                    {certificateUrl}
                </a>
            </p>
        </div>
    );
};

export default CertificateQRCode;
